import { h } from 'preact';
import { SelectEntry } from '../entries/SelectEntry';

const getSplitTypes = (i18n) => [
  { value: '', label: i18n['opt.default'] || '-- Default --' },
  { value: 'xor', label: i18n['opt.splitXor'] || 'XOR (Exclusive)' },
  { value: 'or', label: i18n['opt.splitOr'] || 'OR (Inclusive)' },
  { value: 'and', label: i18n['opt.splitAnd'] || 'AND (Parallel)' },
];

const getJoinTypes = (i18n) => [
  { value: '', label: i18n['opt.default'] || '-- Default --' },
  { value: 'xor', label: i18n['opt.xor'] || 'XOR' },
  { value: 'or', label: i18n['opt.or'] || 'OR' },
  { value: 'and', label: i18n['opt.and'] || 'AND' },
];

const GATEWAY_TYPES = [
  'epx:ExclusiveGateway',
  'epx:ParallelGateway',
  'epx:InclusiveGateway',
  'epx:ComplexGateway',
  'epx:EventBasedGateway',
];

export class GatewayPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return GATEWAY_TYPES.includes(elementType);
  }

  getGroups(element) {
    const { lf, i18n } = { lf: this._lf, i18n: this._i18n };
    const props = element.properties || {};
    const id = element.id;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
      lf.emit('node:properties-change', { id, properties: { [key]: value } });
    };

    return [
      {
        id: 'gateway',
        label: i18n.gateway || 'Gateway',
        entries: [
          {
            id: 'splitType',
            component: () => (
              <SelectEntry
                id="epx-splitType"
                label={i18n.splitType || 'Split Type'}
                value={props.splitType || ''}
                options={getSplitTypes(i18n)}
                onChange={(val) => update('splitType', val)}
              />
            ),
          },
          {
            id: 'joinType',
            component: () => (
              <SelectEntry
                id="epx-joinType"
                label={i18n.joinType || 'Join Type'}
                value={props.joinType || ''}
                options={getJoinTypes(i18n)}
                onChange={(val) => update('joinType', val)}
              />
            ),
          },
        ],
      },
    ];
  }
}
